import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["main", "mainImage", "mainRatio", "grid", "row", "thumb"]

  connect() {
    this.onResize = this.adjust.bind(this)
    window.addEventListener('resize', this.onResize)

    this._onMainImgLoad = () => this.adjust()
    const img = this.hasMainImageTarget ? this.mainImageTarget : this.element.querySelector('[data-hero-layout-target="main"] img')
    if (img) img.addEventListener('load', this._onMainImgLoad, { once: true })

    this._ro = new ResizeObserver(() => this.adjust())
    if (this.hasMainTarget) this._ro.observe(this.mainTarget)
    if (this.hasGridTarget) this._ro.observe(this.gridTarget)

    requestAnimationFrame(() => this.adjust())
  }

  disconnect() {
    window.removeEventListener('resize', this.onResize)
    if (this._ro) this._ro.disconnect()
  }

  adjust() {
    try {
      // Disable JS-driven height setting to avoid layout jumps.
      // Let CSS handle square thumbnails via aspect-ratio instead.
      this.rowTargets.forEach(r => r.style.height = '')
    } catch (e) {
      console.warn('hero-layout adjust failed', e)
    }
  }
}
